import { useEffect, useState } from "react";
import { useAuth } from "../../js/hooks/useAuth";
import {
  BETA_WELCOME_CLOSED,
  hasSeenBetaWelcome,
  hasSeenDeskHint,
  markDeskHintSeen,
} from "../../js/auth/betaUi";

export default function BetaDeskHint() {
  const { session } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    function sync() {
      if (!session?.betaTester || !session.userId) {
        setOpen(false);
        return;
      }
      setOpen(hasSeenBetaWelcome(session.userId) && !hasSeenDeskHint(session.userId));
    }
    sync();
    window.addEventListener(BETA_WELCOME_CLOSED, sync);
    return () => window.removeEventListener(BETA_WELCOME_CLOSED, sync);
  }, [session?.betaTester, session?.userId]);

  if (!open) return null;

  function dismiss() {
    markDeskHintSeen(session.userId);
    setOpen(false);
  }

  return (
    <span className="desk-hint" role="status">
      <span className="desk-hint__bubble">
        Your Desk is always available in the upper-right corner.
        <button type="button" className="desk-hint__ok" onClick={dismiss}>
          Got it
        </button>
      </span>
    </span>
  );
}
